import AdminAddPasein from "../../components/NotFoundPage/NotFoundPage";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
